import range from 'lodash/range';
import {PaginationInfo} from '../design-system/organisms/Pagination/PaginationInfo.interface';

export function getPaginationInfo({
  totalCount,
  currentPage,
  contentsPerPage = 10,
  pagingSize = 5,
}: {
  totalCount: number;
  currentPage?: number;
  contentsPerPage?: number;
  pagingSize?: number;
}): PaginationInfo {
  if (totalCount === 0 || currentPage === undefined) {
    return {
      pages: [],
      prevPage: undefined,
      nextPage: undefined,
    };
  }
  const maxPage = Math.ceil(totalCount / contentsPerPage);
  const startPage = Math.floor((currentPage - 1) / pagingSize) * pagingSize + 1;
  const endPage = startPage + pagingSize - 1;
  const isStartRange = startPage === 1;
  const isEndRange = maxPage <= endPage;
  const currentPagingSize = isEndRange ? maxPage - startPage + 1 : pagingSize;
  const pages = range(startPage, startPage + currentPagingSize);
  const prevPage = isStartRange ? undefined : startPage - 1;
  const nextPage = isEndRange ? undefined : endPage + 1;
  return {
    pages,
    prevPage,
    nextPage,
  };
}
